import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import { Button } from '@mui/material';
const DeleteconfirmationSection = forwardRef((props, ref) => {
    const def_dialog = {
        message: '',
        title: 'conferma',
    }

    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [confirmDialog, setConfirmDialog] = useState(def_dialog)
    useImperativeHandle(ref, () => ({
        confirmDelete(title, message, confirmCallback, undoCallback, icon, btn_class) {
            setConfirmDialog({
                message: message,
                title: title,
                saveCallback: confirmCallback,
                undoCallback: undoCallback,
                icon: icon || 'trash', 
                btn_class: btn_class || 'error'
            })
            setShowConfirmModal(true)
        }
    }));
    const handleClose = () => {
        if (confirmDialog.undoCallback) {
            try {
                confirmDialog.undoCallback()
            } catch (err) {
                console.log( "(DeleteconfirmationSection) ", err)
            }
        }
        setShowConfirmModal(false)
    }
    const handleSave = () => {
        if (confirmDialog.saveCallback) {
            try {
                confirmDialog.saveCallback()
            } catch (err) {
                console.log("|||||error|||||", err)
            }
        }
        setShowConfirmModal(false)
    }

    return <div className="deleteconfirmation_container">
        <Dialog open={showConfirmModal} onClose={handleClose} maxWidth="md" fullWidth={true}>
            <DialogTitle>
                {confirmDialog.title}
            </DialogTitle>
            <DialogContent>
            <div dangerouslySetInnerHTML={{ __html:  confirmDialog.message}}/>
            </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>
                       Annulla 
                    </Button>
                    <Button variant="outlined" color={confirmDialog.btn_class} onClick={handleSave}>
                        Conferma
                    </Button>
                </DialogActions>
        </Dialog>
    </div>
})
export default DeleteconfirmationSection